/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {EventBasicInfo} from '../models/EventBasicInfo';
import type {EventDetailInfo} from '../models/EventDetailInfo';
import type {EventType} from '../models/EventType';
import type {UserEventBasicInfo} from '../models/UserEventBasicInfo';

export interface GetAllEvents$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllEventsRequest = createAction<PayloadData<void>>('EVENT_CONTROLLER__GET_ALL_EVENTS__REQUEST');
export const getAllEventsSuccess = createAction<PayloadData<Array<EventBasicInfo>>>('EVENT_CONTROLLER__GET_ALL_EVENTS__SUCCESS');
export const getAllEventsFailure = createAction<PayloadData<Error, void, true>>('EVENT_CONTROLLER__GET_ALL_EVENTS__FAILURE');

export const getAllEventsActions = [
    getAllEventsRequest,
    getAllEventsSuccess,
    getAllEventsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllEvents = (config?: GetAllEvents$Config) => {
    return {
        CALL_API: {
            types: getAllEventsActions,
            method: ApiMethods.GET,
            endpoint: `/events`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetAllUserEvents$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllUserEventsRequest = createAction<PayloadData<void>>('EVENT_CONTROLLER__GET_ALL_USER_EVENTS__REQUEST');
export const getAllUserEventsSuccess = createAction<PayloadData<Array<UserEventBasicInfo>>>('EVENT_CONTROLLER__GET_ALL_USER_EVENTS__SUCCESS');
export const getAllUserEventsFailure = createAction<PayloadData<Error, void, true>>('EVENT_CONTROLLER__GET_ALL_USER_EVENTS__FAILURE');

export const getAllUserEventsActions = [
    getAllUserEventsRequest,
    getAllUserEventsSuccess,
    getAllUserEventsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllUserEvents = (config?: GetAllUserEvents$Config) => {
    return {
        CALL_API: {
            types: getAllUserEventsActions,
            method: ApiMethods.GET,
            endpoint: `/public/events`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetEventByCodeAndSourceAndType$Request {
    eventCode: string;
    eventSource: string;
    eventType: EventType;
}

export interface GetEventByCodeAndSourceAndType$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEventByCodeAndSourceAndTypeRequest = createAction<PayloadData<void, GetEventByCodeAndSourceAndType$Request>>('EVENT_CONTROLLER__GET_EVENT_BY_CODE_AND_SOURCE_AND_TYPE__REQUEST');
export const getEventByCodeAndSourceAndTypeSuccess = createAction<PayloadData<EventBasicInfo, GetEventByCodeAndSourceAndType$Request>>('EVENT_CONTROLLER__GET_EVENT_BY_CODE_AND_SOURCE_AND_TYPE__SUCCESS');
export const getEventByCodeAndSourceAndTypeFailure = createAction<PayloadData<Error, GetEventByCodeAndSourceAndType$Request, true>>('EVENT_CONTROLLER__GET_EVENT_BY_CODE_AND_SOURCE_AND_TYPE__FAILURE');

export const getEventByCodeAndSourceAndTypeActions = [
    getEventByCodeAndSourceAndTypeRequest,
    getEventByCodeAndSourceAndTypeSuccess,
    getEventByCodeAndSourceAndTypeFailure
] as const;

/**
 * @param {string} meta.eventCode Event code
 * @param {string} meta.eventSource Event source
 * @param {EventType} meta.eventType Event type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEventByCodeAndSourceAndType = (meta: GetEventByCodeAndSourceAndType$Request, config?: GetEventByCodeAndSourceAndType$Config) => {
    const TRANSPORT_GET_PARAMS = {
        eventCode: meta.eventCode,
        eventSource: meta.eventSource,
        eventType: meta.eventType,
    };
    return {
        CALL_API: {
            types: getEventByCodeAndSourceAndTypeActions,
            method: ApiMethods.GET,
            endpoint: `/events/by-code-source-type`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEventById$Request {
    id: number;
}

export interface GetEventById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEventByIdRequest = createAction<PayloadData<void, GetEventById$Request>>('EVENT_CONTROLLER__GET_EVENT_BY_ID__REQUEST');
export const getEventByIdSuccess = createAction<PayloadData<EventDetailInfo, GetEventById$Request>>('EVENT_CONTROLLER__GET_EVENT_BY_ID__SUCCESS');
export const getEventByIdFailure = createAction<PayloadData<Error, GetEventById$Request, true>>('EVENT_CONTROLLER__GET_EVENT_BY_ID__FAILURE');

export const getEventByIdActions = [
    getEventByIdRequest,
    getEventByIdSuccess,
    getEventByIdFailure
] as const;

/**
 * @param {number} meta.id Event id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEventById = (meta: GetEventById$Request, config?: GetEventById$Config) => {
    return {
        CALL_API: {
            types: getEventByIdActions,
            method: ApiMethods.GET,
            endpoint: `/events/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEventCount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEventCountRequest = createAction<PayloadData<void>>('EVENT_CONTROLLER__GET_EVENT_COUNT__REQUEST');
export const getEventCountSuccess = createAction<PayloadData<number>>('EVENT_CONTROLLER__GET_EVENT_COUNT__SUCCESS');
export const getEventCountFailure = createAction<PayloadData<Error, void, true>>('EVENT_CONTROLLER__GET_EVENT_COUNT__FAILURE');

export const getEventCountActions = [
    getEventCountRequest,
    getEventCountSuccess,
    getEventCountFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEventCount = (config?: GetEventCount$Config) => {
    return {
        CALL_API: {
            types: getEventCountActions,
            method: ApiMethods.GET,
            endpoint: `/events/count`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface RemoveEventById$Request {
    id: number;
}

export interface RemoveEventById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeEventByIdRequest = createAction<PayloadData<void, RemoveEventById$Request>>('EVENT_CONTROLLER__REMOVE_EVENT_BY_ID__REQUEST');
export const removeEventByIdSuccess = createAction<PayloadData<void, RemoveEventById$Request>>('EVENT_CONTROLLER__REMOVE_EVENT_BY_ID__SUCCESS');
export const removeEventByIdFailure = createAction<PayloadData<Error, RemoveEventById$Request, true>>('EVENT_CONTROLLER__REMOVE_EVENT_BY_ID__FAILURE');

export const removeEventByIdActions = [
    removeEventByIdRequest,
    removeEventByIdSuccess,
    removeEventByIdFailure
] as const;

/**
 * @param {number} meta.id Event Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeEventById = (meta: RemoveEventById$Request, config?: RemoveEventById$Config) => {
    return {
        CALL_API: {
            types: removeEventByIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/events/remove/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

